
                  export default function (Component) {
                      Component.__source = "library/components/VabFullScreen/index.vue"
                  }
              